import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=756a70b6&scoped=true&lang=pug&"
import script from "./ImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=756a70b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a70b6",
  null
  
)

export default component.exports